<template>
    <div class="dashboard-window" v-if="data">
        <div class="dashboard-window-header">
            <div class="window-header__title">
                Мои метрики
            </div>
        </div>
        <div class="dashboard-window-body" :class="{ expanded: isExpanded }">
            <div class="dashboard-window-body-item">
                <div class="dashboard-window-body-item__circle">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.5853 9.35189C20.8585 10.2082 20.9995 11.1012 21.0035 12C21.0035 16.9726 16.9724 21.0037 11.9997 21.0037C7.02709 21.0037 2.99597 16.9726 2.99597 12C2.99597 7.02736 7.02709 2.99625 11.9997 2.99625C12.8985 3.00024 13.7915 3.14125 14.6478 3.41442" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M21.0035 4.27078L19.0147 6.25961L17.7391 4.98408" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.5004 14.501C11.5666 14.501 9.9989 12.9334 9.9989 10.9996C9.9989 9.06578 11.5666 7.49812 13.5004 7.49812C15.4342 7.49812 17.0018 9.06578 17.0018 10.9996C17.0018 12.9334 15.4342 14.501 13.5004 14.501" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10.329 9.51697C8.61849 9.59709 7.21804 10.9049 7.02127 12.606C6.82451 14.307 7.88941 15.9001 9.53646 16.3686C11.1835 16.8371 12.9274 16.043 13.6554 14.493" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <p>{{ formatNumber(data.revenue) }}</p>
                <span>Выручка со скидками (₽)</span>
            </div>

            <div class="dashboard-window-body-item">
                <div class="dashboard-window-body-item__circle">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 15.9H3.9C2.85 15.9 2 15.05 2 14V4.9C2 3.85 2.85 3 3.9 3H19.1C20.15 3 21 3.85 21 4.9V10" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 13H5" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 6H17" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.5 20C16.567 20 15 18.433 15 16.5C15 14.567 16.567 13 18.5 13C20.434 13 22 14.567 22 16.5C22 18.433 20.434 20 18.5 20" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15.33 15.018C13.478 15.108 12 16.626 12 18.5C12 20.433 13.567 22 15.5 22C16.897 22 18.093 21.176 18.655 19.992" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.1793 7.97099C14.1063 8.89799 14.1063 10.402 13.1793 11.33C12.2523 12.257 10.7483 12.257 9.82025 11.33C8.89325 10.403 8.89325 8.89899 9.82025 7.97099C10.7483 7.04299 12.2523 7.04299 13.1793 7.97099" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <p>{{ formatNumber(data.revenue_without_discounts) }}</p>
                <span>Выручка без скидок (₽)</span>
            </div>

            <div class="dashboard-window-body-item">
                <div class="dashboard-window-body-item__circle">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8086 7.191C15.9537 7.33606 15.9537 7.57116 15.8086 7.71622C15.6635 7.86128 15.4284 7.86128 15.2834 7.71622C15.1383 7.57116 15.1383 7.33606 15.2834 7.191C15.4294 7.04594 15.6635 7.04594 15.8086 7.191" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.077 12.2841L19.3865 10.9746C19.7817 10.5784 20.0038 10.0442 20.0038 9.48595V5.09912C20.0038 3.93764 19.0624 2.99625 17.8989 2.99625H13.5121C12.9548 2.99625 12.4196 3.21834 12.0265 3.6125L3.61295 12.026C2.79161 12.8473 2.79161 14.1789 3.61295 15.0002L7.99978 19.3871C8.82112 20.2084 10.1527 20.2084 10.974 19.3871L12.2846 18.0765" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.253 15.6265L16.0641 17.8154L14.7516 16.5019" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.5027 21.0038C14.0167 21.0038 12.0009 18.9879 12.0009 16.5019C12.0009 14.0669 14.0717 11.998 16.5057 12C18.9908 12.002 21.0046 14.0168 21.0046 16.5019C21.0046 18.9879 18.9898 21.0038 16.5027 21.0038" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <p>{{ formatNumber(data.discounts_sum) }}</p>
                <span>Сумма скидок (₽)</span>
            </div>

            <div class="dashboard-window-body-item">
                <div class="dashboard-window-body-item__circle">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 18C3 15.791 4.791 14 7 14H11C13.209 14 15 15.791 15 18" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16 4.651C17.381 4.651 18.5 5.77 18.5 7.151C18.5 8.532 17.381 9.651 16 9.651" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.4049 4.99613C12.7331 6.3243 12.7331 8.4777 11.4049 9.80587C10.0767 11.134 7.92333 11.134 6.59516 9.80587C5.26699 8.4777 5.26699 6.3243 6.59516 4.99613C7.92333 3.66796 10.0767 3.66796 11.4049 4.99613" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17 13C19.209 13 21 14.791 21 17" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <p>{{ formatNumber(data.orders_count) }} / {{ formatNumber(data.guests) }}</p>
                <span>Чеков / гостей</span>
            </div>

            <div class="dashboard-window-body-item">
                <div class="dashboard-window-body-item__circle">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 12H12" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.339 21H5.348C4.051 21 3 19.949 3 18.652V5.348C3 4.051 4.051 3 5.348 3H18.652C19.948 3 21 4.051 21 5.348V13.339" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 22V22C13.462 22 11 19.538 11 16.5V16.5C11 13.462 13.462 11 16.5 11V11C19.538 11 22 13.462 22 16.5V16.5C22 19.538 19.538 22 16.5 22Z" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 17.75H18" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 15.25H18" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 7.5H18" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 7.5H9" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.5 9V6" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.44043 15.44L8.56043 17.56" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.44043 17.56L8.56043 15.44" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 3V12" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <p>{{ formatNumber(data.average_check) }} / {{ formatNumber(data.guest_average_check) }}</p>
                <span>Средний чек / гость (₽)</span>
            </div>

            <div class="dashboard-window-body-item">
                <div class="dashboard-window-body-item__circle">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12.266V8.09099C4 6.84299 4.773 5.72499 5.94 5.28399L14.293 2.12999C15.602 1.63699 17 2.60299 17 4.00199V7.35199" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10.652 21H18C19.65 21 21 19.65 21 18V10.351C21 8.694 19.657 7.351 18 7.351H6C4.895 7.351 4 8.246 4 9.351" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17.249 14.101C17.111 14.102 17 14.214 17 14.352C17 14.49 17.112 14.602 17.25 14.601C17.388 14.601 17.5 14.489 17.5 14.351C17.5 14.213 17.388 14.101 17.249 14.101" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.84863 18.15L9.14863 14.85" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.29902 18.034C9.37302 18.108 9.37302 18.227 9.29902 18.3C9.22502 18.374 9.10602 18.374 9.03302 18.3C8.95902 18.226 8.95902 18.107 9.03302 18.034C9.10502 17.96 9.22502 17.96 9.29902 18.034" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.96698 14.699C6.04098 14.773 6.04098 14.892 5.96698 14.965C5.89298 15.039 5.77398 15.039 5.70098 14.965C5.62798 14.891 5.62698 14.772 5.70098 14.699C5.77498 14.626 5.89398 14.625 5.96698 14.699" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 22C10.525 22 13 19.525 13 16.5C13 13.475 10.525 11 7.5 11C4.475 11 2 13.475 2 16.5C2 17.734 2.417 18.873 3.11 19.792C4.115 21.129 5.709 22 7.5 22Z" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <p>{{ formatNumber(data.average_order_time) }}</p>
                <span>Cреднее время обслуживания (мин.)</span>
            </div>

            <div class="dashboard-window-body-item__more" @click="toggleBlocks">
                <svg width="36px" height="36px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="24" height="24" fill="white"></rect> <path d="M17 9.5L12 14.5L7 9.5" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
            </div>
        </div>
    </div>
</template>
<script>
import { formatNumber } from '@/utils/numberFormat'

export default {
    data() {
        return {
            isExpanded: false
        }
    },

    props: {
        data: {
            type: Object,
            default: null
        }
    },

    methods: {
        formatNumber,

        toggleBlocks() {
            this.isExpanded = !this.isExpanded
        }
    }
}
</script>
<style scoped lang="scss">
.dashboard-window {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    font-family: 'SFProDisplay', sans-serif;
    background: var(--color-white);
    border-radius: 16px;
    border: 1px solid #F5F5F5;
    overflow: hidden;
    @media only screen and (max-width: 425px) {
        padding-bottom: 8px;
    }
    
    &-header {
        font-size: 16px;
        font-weight: 700;
    }

    &-body {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 16px;
        @media only screen and  (max-width: 425px) {
            grid-template-columns: 1fr;
        }
        &-item {
            padding: 10px 14px;
            display: grid;
            grid-template-columns: 50px 1fr;
            grid-column-gap: 12px;
            align-items: center;
            background: #FAFAFA;
            border-radius: 16px;
            &__circle {
                grid-row: 1 / 3;
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 50px;
                min-height: 50px;
                max-width: 50px;
                max-height: 50px;
                background: #B8E6FF;
                border-radius: 50%;
            }
            & p {
                font-size: 20px;
                font-weight: 600;
                @media only screen and  (max-width: 1440px) {
                    font-size: 16px;
                }
            }
            & span {
                font-size: 14px;
                font-weight: 500;
                color: #737373;
                @media only screen and  (max-width: 1440px) {
                    font-size: 12px;
                }
            }
            &__more {
                display: none;
                align-items: center;
                justify-content: center;
                transition: 0.3s;
                @media only screen and (max-width: 425px) {
                    display: flex;
                }
            }
        }
    }
}

@media only screen and (max-width: 425px) {
    .dashboard-window-body-item:nth-child(n+4) {
        display: none;
    }

    .dashboard-window-body.expanded .dashboard-window-body-item {
        display: grid;
    }

    .dashboard-window-body.expanded .dashboard-window-body-item__more svg {
        transform: rotate(180deg);
    }
}
</style>